import { useTheme } from 'styled-components';
import Tags from '../../../../components/common/Tags';
import { ThemeType } from '../../../../theme/themeType';
import ClockCounter from '../../../../components/common/ClockCounter/ClockCounter';
import { convertMsToKm } from '../../../../utils/unitsUtils';
import useGetFleetId from '../../../../API/hooks/useGetFleetId';
import useDeviceOnlineStatus from '../../../../API/hooks/devices/useDeviceOnlineStatus';
import DataPendingTag from '../../../../components/common/DataPendingTag/DataPendingTag';

type Props = {
  startAt: string;
  speedMs?: number;
  deviceId?: string;
};

function OngoingTripStatus({ startAt, speedMs, deviceId }: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const fleetId = useGetFleetId();
  const { data } = useDeviceOnlineStatus(fleetId, deviceId ?? null);
  const isOnline = data?.isOnline ?? false;

  return (
    <div className="tags-container">
      <Tags.Status
        label="Ongoing"
        backgroundColor={theme.colors.main_cta}
      />
      {isOnline ? (
        <>
          <ClockCounter lastTime={startAt} />
          <Tags.Label
            label={`Current speed: ${speedMs !== null && speedMs !== undefined ? `${convertMsToKm(speedMs)} km/h` : 'n/a'}`}
          />
        </>
      ) : (
        <DataPendingTag startAt={startAt} />
      )}
    </div>
  );
}

export default OngoingTripStatus;
